/* eslint-disable no-unused-vars */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";

export interface TronAccount {
  address: string;
  balance: number;
  frozenV2?: {
    type?: string;
    amount?: number;
  }[];
  frozen?: {
    frozen_balance: number;
    expire_time: number;
  }[];
}

export interface FreezeBalancePayload {
  amount: number;
  resource?: "BANDWIDTH" | "ENERGY";
}

export interface UnfreezeBalancePayload {
  amount: number;
  resource?: "BANDWIDTH" | "ENERGY";
}

export const tronStakingApi = createApi({
  reducerPath: "tronStakingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseHref}/tron-staking`,
    credentials: "include",
  }),
  tagTypes: ["tronAccount"],
  endpoints: (builder) => ({
    getAccount: builder.query<TronAccount, string>({
      query: (address) => `get-account?address=${address}`,
      providesTags: ["tronAccount"],
    }),

    freezeBalance: builder.mutation<any, FreezeBalancePayload>({
      query: (body) => ({
        url: `freeze-balance`,
        method: "GET",
        params: body,
      }),
      invalidatesTags: ["tronAccount"],
    }),

    unfreezeBalance: builder.mutation<any, UnfreezeBalancePayload>({
      query: (body) => ({
        url: `unfreeze-balance`,
        method: "GET",
        params: body,
      }),
      invalidatesTags: ["tronAccount"],
    }),
  }),
});

export const {
  useGetAccountQuery,
  useFreezeBalanceMutation,
  useUnfreezeBalanceMutation,
} = tronStakingApi;
